import { render, staticRenderFns } from "./newFileView.vue?vue&type=template&id=6374304a&scoped=true"
import script from "./newFileView.vue?vue&type=script&lang=js"
export * from "./newFileView.vue?vue&type=script&lang=js"
import style0 from "./newFileView.vue?vue&type=style&index=0&id=6374304a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6374304a",
  null
  
)

export default component.exports